import { FC } from 'react';
import Image from 'next/image';
import { relativeLoader } from 'src/common/utils/imageHelpers';
import { NEXT_STATIC_IMAGES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import { useTranslation } from 'next-i18next';
import styles from './ImageSection.module.scss';

const ImageSection: FC = () => {
  const [t] = useTranslation('press-page');
  return (
    <PitchPageLayout backgroundColor="midnight02">
      <div className={styles.root}>
        <div className={styles.imageWrapper}>
          <Image
            src={`${NEXT_STATIC_IMAGES}media/media-kit-1.jpg`}
            loader={relativeLoader}
            width={478}
            height={324}
            loading="eager"
            alt={t('image-1--alt')}
            className={styles.image1}
          />
        </div>
        <div className={styles.imageWrapper}>
          <Image
            src={`${NEXT_STATIC_IMAGES}media/media-kit-2.jpg`}
            loader={relativeLoader}
            width={391}
            height={334}
            loading="eager"
            alt={t('image-2--alt')}
            className={styles.image2}
          />
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default ImageSection;
